// extracted by mini-css-extract-plugin
export default {"Home":"FoursourceHome_Home__NKlX1"};